import Landscaping from "./pages/ServiceDetails/Landscaping";
import Solar from "./pages/ServiceDetails/Solar";
import Roofing from "./pages/ServiceDetails/Roofing";
import HVAC from "./pages/ServiceDetails/HVAC";
import Plumbing from "./pages/ServiceDetails/Plumbing";
import Electrical from "./pages/ServiceDetails/Electrical";
import ContractorPricing from "./pages/Contractors/Pricing";
import ServicesPage from "./pages/Services";
import ContractorCheckout from "./pages/Contractors/Checkout";
import ContractorPortal from "./pages/Contractors/Portal";
import React, { Suspense } from "react";
import { HashRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import BBHeader from "./components/layout/Header";
import SiteFooter from "./components/layout/Footer";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import AdminLeads from "./pages/AdminLeads";
import AdminLeadsAnalytics from "./pages/AdminLeadsAnalytics";
import LeadsDashboard from "./pages/LeadsDashboard";
import BillingDiag from "./pages/BillingDiag";
import AdminMfaVerify from "./pages/admin/AdminMfaVerify";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminContractors from "./pages/admin/AdminContractors";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminAddLead from "./pages/admin/AdminAddLead";
import YelpLanding from "./pages/YelpLanding";
import ContractorLogin from "./pages/Contractors/Login";
import ContractorSuccess from "./pages/Contractors/Success";
import ContractorSignUp from "./pages/contractor/SignUp";
import ContractorForgot from "./pages/contractor/Forgot";
import ContractorReset from "./pages/contractor/Reset";
import ContractorVerify from "./pages/contractor/Verify";
import QuoteWizard from "./pages/QuoteWizard";
import DisclaimerGate from "./components/legal/DisclaimerGate";


// Lazy pages
const Home = React.lazy(() => import("./pages/Home.jsx"));
const GetQuotesWorking = React.lazy(() => import("./pages/GetQuotesWorking.jsx"));
const Thanks = React.lazy(() => import("./pages/Thanks.js"));

function ContractorLoginRedirect() {
  const loc = useLocation();
  return <Navigate to={`/contractors/login${loc.search || ""}`} replace />;
}

function QuoteRedirect() {
  const loc = useLocation();
  const hashQueryMatch = window.location.hash.match(/\?(.+)$/);
  const hashQuery = hashQueryMatch ? `?${hashQueryMatch[1]}` : "";
  const query = loc.search || hashQuery;
  return <Navigate to={`/get-quotes${query}`} replace />;
}


export default function App() {
  // Fix for HashRouter: if user lands on a path like /contractors/pricing without a hash, redirect them
  React.useEffect(() => {
    if (window.location.pathname && window.location.pathname !== '/' && window.location.hash === '') {
      window.location.replace('/#' + window.location.pathname + window.location.search);
    }
  }, []);

  // Kill any legacy mini-footer (keeps the new dark footer)
  React.useEffect(() => {
    try {
      document.querySelectorAll("footer").forEach((el) => {
        const txt = (el.textContent || "").toLowerCase();
        const cls = el.className || "";
        const isDark =
          cls.includes("bg-neutral-900") || cls.includes("bg-black");
        const looksMini =
          txt.includes("buildbright") && txt.includes("rights reserved");
        const hasEmail =
          txt.includes("alfred3999@gmail.com") ||
          txt.includes("buildbrightusa@gmail.com") ||
          txt.includes("support@buildbright.app");
        if (!isDark && (looksMini || hasEmail)) el.remove();
      });
    } catch {}
  }, []);

  return (
    <HashRouter>
      <div className="min-h-screen flex flex-col">
        <BBHeader />
        <div className="flex-1">
          <Suspense fallback={null}>
                      <Routes>
            <Route path="/contractors/signup" element={<ContractorSignUp />} />          
            <Route path="/contractor/sign-up" element={<ContractorSignUp />} />          
            <Route path="/contractors/success" element={<ContractorSuccess />} />        
            <Route path="/contractors/login" element={<ContractorLogin />} />                  
            <Route path="/contractors/portal" element={<ContractorPortal />} />
            <Route path="/" element={<Home />} />
            <Route path="/quote" element={<QuoteRedirect />} />
            <Route path="/get-quotes" element={<GetQuotesWorking />} />
            <Route path="/thanks" element={<Thanks />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contractor/sign-in" element={<ContractorLoginRedirect />} />
            <Route path="/contractor/login" element={<ContractorLoginRedirect />} />
            <Route path="/contractor/signin" element={<ContractorLoginRedirect />} />
            <Route path="/contractor/forgot" element={<ContractorForgot />} />
            <Route path="/contractor/reset" element={<ContractorReset />} />
            <Route path="/contractor/verify" element={<ContractorVerify />} />
            <Route path="/for-contractors" element={<ContractorPricing />} />
            <Route
              path="/contractors/pricing"
              element={<ContractorPricing />}
            />
            <Route
              path="/contractors/checkout"
              element={<ContractorCheckout />}
            />

            <Route path="/services/roofing" element={<Roofing />} />
            <Route path="/services/solar" element={<Solar />} />
            <Route path="/services/landscaping" element={<Landscaping />} />
            <Route path="/services/hvac" element={<HVAC />} />
            <Route path="/services/plumbing" element={<Plumbing />} />
            <Route path="/services/electrical" element={<Electrical />} />

            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />

            {/* Legal pages */}
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            
           <Route path="/blog" element={<BlogIndex />} />
           <Route path="/blog/:slug" element={<BlogPost />} />

           <Route path="/admin/leads" element={<AdminLeads />} />
           <Route path="/admin/login" element={<AdminLogin />} />
           <Route path="/admin/mfa/verify" element={<AdminMfaVerify />} />
           <Route path="/admin/dashboard" element={<AdminDashboard />} />
           <Route path="/admin/contractors" element={<AdminContractors />} />
           <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/add-lead" element={<AdminAddLead />} />
            <Route path="/yelp" element={<YelpLanding />} />
           <Route path="/admin" element={<AdminLogin />} />
           <Route
           path="/admin/leads/analytics"
           element={<AdminLeadsAnalytics />}
           />
           <Route path="/diag/leads" element={<LeadsDashboard />} />
           <Route path="/diag/billing" element={<BillingDiag />} />


          </Routes>

          </Suspense>
        </div>
        <DisclaimerGate />
        <SiteFooter lastUpdated="September 28, 2025" />
      </div>
    </HashRouter>
  );
}
